// Display context and hook — AgDR-0039. Kept apart from <DisplayProvider> so that
// display-provider.tsx exports components only (React Fast Refresh).
import { createContext, useContext } from 'react';

export type Density = 'compact' | 'comfortable' | 'cozy';
// Text size steps, as a multiple of the browser's base size (AgDR-0288 §3):
// M = 100 % (the default) up to XXL = 200 %. No step goes below 100 %.
export type FontScale = 'M' | 'L' | 'XL' | 'XXL';

export interface DisplayContextValue {
  density: Density;
  fontScale: FontScale;
  setDensity: (d: Density) => void;
  setFontScale: (s: FontScale) => void;
}

export const DisplayContext = createContext<DisplayContextValue | undefined>(undefined);

export function useDisplay(): DisplayContextValue {
  const ctx = useContext(DisplayContext);
  if (!ctx) throw new Error('useDisplay must be used inside <DisplayProvider>');
  return ctx;
}
